import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'highlightText',
    standalone: false
})
export class HighlightTextPipe implements PipeTransform {
  transform(
    value: string,
    args: string,
    className: string = 'is-underlined'
  ): string {
    if (!value || !args) {
      return value;
    }

    return value.replace(new RegExp(args, 'gi'), `<span class="${className}">$&</span>`);
  }
}
